module.exports = __webpack_public_path__ + "img/key-concepts.33cb36ec.png";